import { isNumber } from "angular";
import { Rect } from "@gtmhub/shared/models";

export function offset(elem, doc: Document): Rect {
  elem = elem[0] || elem;

  const elemBCR = elem.getBoundingClientRect();
  return {
    width: Math.round(isNumber(elemBCR.width) ? elemBCR.width : elem.offsetWidth),
    height: Math.round(isNumber(elemBCR.height) ? elemBCR.height : elem.offsetHeight),
    top: Math.round(elemBCR.top + (window.scrollY || doc[0].documentElement.scrollTop)),
    left: Math.round(elemBCR.left + (window.scrollX || doc[0].documentElement.scrollLeft)),
  };
}

export function getDistanceSq(anchor: unknown, pos: Rect, e): number {
  const width = pos.width;
  const height = pos.height;
  const x = e.pageX - pos.left;
  const y = e.pageY - pos.top;
  let anchorX = width / 2;
  let anchorY = height / 2;

  if (typeof anchor === "string" && anchor.indexOf("left") >= 0) anchorX = width / 4;
  if (typeof anchor === "string" && anchor.indexOf("top") >= 0) anchorY = height / 4;
  if (typeof anchor === "string" && anchor.indexOf("right") >= 0) anchorX = (width * 3) / 4;
  if (typeof anchor === "string" && anchor.indexOf("bottom") >= 0) anchorY = (height * 3) / 4;

  return Math.pow(anchorX - x, 2) + Math.pow(anchorY - y, 2);
}
